<template>
  <page-view title>
    <div slot="headerContent">
      <search-robot @changeRobotId="onChangeRobotId(arguments)"></search-robot>
    </div>
    <div :style="{ marginBottom: '10px' }">
      <demo-video-alert name="DingDanGuanLi"></demo-video-alert>
    </div>
    <exception-page type="norobot" v-if="!currentRobotId" />
    <a-card :bordered="false" v-if="currentRobotId">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="搜索条件">
                <a-select v-model="queryParam.search_condition" placeholder="请选择" allowClear>
                  <a-select-option value="1">订单号</a-select-option>
                  <a-select-option value="2">商品ID</a-select-option>
                  <a-select-option value="3">会员ID</a-select-option>
                  <a-select-option value="4">微信ID</a-select-option>
                  <a-select-option value="5">商品名称</a-select-option>
                  <a-select-option value="6">会员昵称</a-select-option>
                  <a-select-option value="7">推广位</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="搜索关键字">
                <a-input v-model="queryParam.keywords" placeholder="请输入" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单状态">
                <a-select v-model="queryParam.order_condition" placeholder="请选择" allowClear>
                  <a-select-option value="12">订单付款</a-select-option>
                  <a-select-option value="3">订单结算</a-select-option>
                  <a-select-option value="13">订单失效</a-select-option>
                  <a-select-option value="4">订单退款</a-select-option>
                  <a-select-option value="14">订单成功</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-drawer
              :width="500"
              title="查询条件"
              placement="right"
              :footer-style="{ textAlign: 'right' }"
              :visible="searchDrawerVisible"
              @close="searchDrawerClose"
            >
              <div class="table-page-search-wrapper">
                <a-form layout="inline">
                  <a-form-item label="搜索条件">
                    <a-select v-model="queryParam.search_condition" placeholder="请选择" allowClear>
                      <a-select-option value="1">订单号</a-select-option>
                      <a-select-option value="2">商品ID</a-select-option>
                      <a-select-option value="3">会员ID</a-select-option>
                      <a-select-option value="4">微信ID</a-select-option>
                      <a-select-option value="5">商品名称</a-select-option>
                      <a-select-option value="6">会员昵称</a-select-option>
                      <a-select-option value="7">推广位</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item label="搜索关键字">
                    <a-input v-model="queryParam.keywords" placeholder="请输入" />
                  </a-form-item>

                  <a-form-item label="订单状态">
                    <a-select v-model="queryParam.order_condition" placeholder="请选择" allowClear>
                      <a-select-option value="12">订单付款</a-select-option>
                      <a-select-option value="3">订单结算</a-select-option>
                      <a-select-option value="13">订单失效</a-select-option>
                      <a-select-option value="4">订单退款</a-select-option>
                      <a-select-option value="14">订单成功</a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="返利状态">
                    <a-select v-model="queryParam.rebate_condition" placeholder="请选择" allowClear>
                      <a-select-option value="0">未返利</a-select-option>
                      <a-select-option value="1">已返利</a-select-option>
                      <a-select-option value="2">已退款</a-select-option>
                      <a-select-option value="cold">已冻结</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item label="付款金额小于">
                    <a-input v-model="queryParam.order_pay" placeholder="请输入" />
                  </a-form-item>
                  
                  <a-form-item label="订单排序">
                    <a-select v-model="queryParam.sortField" placeholder="请选择" allowClear>
                      <a-select-option value="tb_paid_time">付款时间</a-select-option>
                      <a-select-option value="tk_earning_time">结算时间</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item label="绑定状态">
                    <a-select v-model="queryParam.bind_status" placeholder="请选择" allowClear>
                      <a-select-option value="2">已绑定订单</a-select-option>
                      <a-select-option value="1">未绑定订单</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item label="朋友圈订单">
                    <a-select v-model="queryParam.extra_type" placeholder="请选择" allowClear>
                      <a-select-option value="0">普通订单</a-select-option>
                      <a-select-option value="1">朋友圈订单</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item label="创建时间-结算时间">
                    <a-range-picker v-model="changeTime" @change="formatTime" :placeholder="['创建时间', '结算时间']"/>
                  </a-form-item>

                </a-form>
              </div>

              <template #footer>
                <a-button style="margin-right: 8px" @click="searchDrawerClose">取消</a-button>
                <a-button type="primary" @click="searchDrawerBtn">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => (queryParam = {},changeTime=[])">重置</a-button>
              </template>
            </a-drawer>
            <a-col :md="6" :sm="24">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="searchDrawerShow">高级查询</a-button>
              <a-button style="margin-left: 8px" @click="() => (queryParam = {},changeTime=[])">重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator" v-if="false">
        <a-button type="primary" :disabled="OrderDownloadStatus.conduct ? true : false" @click="handleDownLoad"
          >同步订单</a-button
        >
        <div style="width: 200px; margin-top: -3px">
          <a-progress
            v-if="OrderDownloadStatus.conduct"
            :percent="OrderDownloadStatus.progress"
            size="small"
            :format="percent => parseInt(percent) + '%'"
          />
        </div>
      </div>
      <a-dropdown placement="bottomLeft" :trigger="['click']" :disabled="selectedRowKeys.length === 0">
        <a-button style="margin-bottom: 10px" type="primary">批量操作</a-button>
        <a-menu slot="overlay">
          <a-menu-item @click="handleMoreJiesuan" :disabled="!canClickMore">
            <a-tooltip>
              <template slot="title" v-if="!canClickMore"> 所选机器人ID不一致 </template>
              批量结算
            </a-tooltip>
          </a-menu-item>
          <a-menu-item @click="handleMoreJiedong" :disabled="!canClickMore">批量解冻</a-menu-item>
          <a-menu-item @click="handleMoreJiebang" :disabled="!canClickMore">批量解绑</a-menu-item>
          <a-menu-item @click="$refs.replaceUidModal.showMore(selectedGoods, sourceby)" :disabled="!canClickMore"
            >批量换绑</a-menu-item
          >
          <a-menu-item @click="handleMoreTuikuan" :disabled="!canClickMore">批量退款</a-menu-item>
        </a-menu>
      </a-dropdown>
      <s-table
        ref="table"
        rowKey="id"
        :scroll="{ x: 300 }"
        :columns="columns"
        :data="loadData"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      >
        <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>

        <span slot="sub_id" slot-scope="text">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ robotName }}</span>
            </template>
            <span v-line-clamp="1">{{ text }}</span>
          </a-tooltip>
        </span>

        <span slot="order_no" slot-scope="text">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <span v-line-clamp="1">{{ text }}</span>
          </a-tooltip>
        </span>
        <!-- 商品标题 -->
        <!-- <span slot="order_title" slot-scope="text, record">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <a :href="'https://item.taobao.com/item.htm?id=' + record.item_id" target="_blank" v-line-clamp="1">{{
              text
            }}</a>
          </a-tooltip>
          <br />
          <a-tag color="#f50" v-if="record.subsidy_type !== '--'">{{ record.subsidy_type }}</a-tag>
        </span> -->
        <span slot="user_info" slot-scope="text, record">
          <a-tooltip placement="left" v-if="text && text != null">
            <template slot="title">
              <span>{{ text.nickname }}（uid:{{ text.uid }}）</span>
            </template>
            <span v-line-clamp="1">{{ text.nickname ? text.nickname : '空用户名' }}</span>
          </a-tooltip>

          <a-tooltip placement="left" v-else>
            <template slot="title">
              <span>{{
                record.binding_miss_remark
                  ? record.binding_miss_remark
                  : record.op_status === 1
                  ? '等待机器人处理'
                  : '请手动绑定订单'
              }}</span>
            </template>
            <a>未绑定 <a-icon type="question-circle" /></a>
          </a-tooltip>
        </span>
        <span slot="item_img" slot-scope="text">
          <a-popover title="商品主图">
            <template slot="content">
              <img :src="text" style="max-width: 200px" />
            </template>
            <a-avatar shape="square" icon="picture" :src="text" />
          </a-popover>
        </span>
        <!-- 付款金额 -->
        <!-- <span slot="rmb_slot" slot-scope="text">
          <span>{{ text || 0 | currency('￥') }}</span>
        </span> -->
        <!-- 总佣金 -->
        <!-- <span slot="total_reward" slot-scope="text, record">
          <span v-if="record.tk_status != 14">
            <span>{{ record.pub_share_pre_fee || 0 | currency('￥') }}</span>
          </span>
          <span v-else>
            <span>{{ record.pub_share_fee || 0 | currency('￥') }}</span>
          </span>
        </span> -->

        <!-- 商品信息 -->
        <span slot="goods_info" slot-scope="text, record">
          <span>
            <a-tooltip placement="top">
              <template slot="title">
                <span>{{ record.item_title }}</span>
              </template>
              <!-- <a :href="'https://item.taobao.com/item.htm?id=' + record.item_id" target="_blank" v-line-clamp="1"> -->
              <a :href="record.item_link" target="_blank" v-line-clamp="1">
                {{ record.item_title }}</a
              >
            </a-tooltip>
            <br />
            <a-tag color="#f50" v-if="record.subsidy_type !== '--'">{{ record.subsidy_type }}</a-tag>
            <a-tag color="purple" v-if="record.tb_deposit_time !== '--'">预售</a-tag>
          </span>
          <a-tag color="green">商品ID：{{ record.item_id }}</a-tag>
          <a-tag color="blue">付款金额：{{ record.alipay_total_price || 0 | currency('￥') }}</a-tag>
        </span>

        <!-- 返利信息 -->
        <span slot="order_fanli_Info_slotd" slot-scope="text, record">
          <span v-if="record.tk_status != 14">
            <a-tag color="pink">总佣金：{{ record.pub_share_pre_fee || 0 | currency('￥') }}</a-tag>
          </span>
          <span v-else>
            <a-tag color="pink">总佣金：{{ record.pub_share_fee || 0 | currency('￥') }}</a-tag>
          </span>
          <a-tag color="blue">用户奖励： {{ record.fl_user }}</a-tag>
          <a-tag color="orange">上级奖励：{{ record.fl_agent }}</a-tag>
          <a-tag color="cyan">上上级奖励： {{ record.fl_second }}</a-tag>
          <a-tag color="purple">群主奖励：{{ record.fl_group }}</a-tag>
        </span>
        <!-- 订单信息 -->
        <span slot="order_info" slot-scope="text, record">
          <span>
            <a-tag v-if="record.tk_status == 12" color="blue">订单付款</a-tag>
            <a-tag v-else-if="record.tk_status == 3" color="green">订单结算</a-tag>
            <a-tag v-else-if="record.tk_status == 13" color="#909399">订单失效</a-tag>
            <a-tag v-else-if="record.tk_status == 4" color="#f50">订单退款</a-tag>
            <a-tag v-else-if="record.tk_status == 14" color="green">订单成功</a-tag>
            <a-tag v-else>{{ record.tk_status | getOrderStatus }}</a-tag>
          </span>
          <span>
            <a-tag color="volcano">{{ record.flstatus | getOrderFanliStatus }}</a-tag>
          </span>
          <span>
            <a-tag color="volcano" v-if="record.luckdrawTAG == '1'">已冻结</a-tag>
            <a-tag color="geekblue" v-else>未冻结</a-tag>
          </span>
          <span>
            <a-tag color="pink">付款时间： {{ record.tb_paid_time ? record.tb_paid_time : '无付款时间' }}</a-tag>
          </span>
          <span>
            <a-tag color="cyan">结算时间： {{ record.tk_earning_time ? record.tk_earning_time : '无' }}</a-tag>
          </span>
          <span>
            <a-tag color="volcano">冻结时间： {{ record.luckdraw_time ? record.luckdraw_time : '无' }}</a-tag>
          </span>
        </span>
        <!-- <span slot="order_status_slot" slot-scope="text">
          <a-badge v-if="text == '12'" status="processing" text="订单付款" />
          <a-badge v-else-if="text == '3'" status="success" text="订单结算" />
          <a-badge v-else-if="text == '13'" status="default" text="订单失效" />
          <a-badge v-else-if="text == '4'" status="default" text="订单退款" />
          <a-badge v-else-if="text == '14'" status="success" text="订单成功" />
          <span v-else>{{ text | getOrderStatus }}</span>
        </span> -->
        <!-- <span slot="order_fanli_status_slot" slot-scope="text">
          <span>{{ text | getOrderFanliStatus }}</span>
        </span> -->
        <!-- <span slot="accountdt" slot-scope="text">
          <span>{{ text ? text : '暂未结算' }}</span>
        </span>
        <span slot="createdt" slot-scope="text">
          <span>{{ text ? text : '无创建时间' }}</span>
        </span> -->
        <span slot="mmpid" slot-scope="text, record">
          <span>{{ record.adzone_id }}</span>
        </span>
        <!-- <span slot="order_dongjie_status_slot" slot-scope="text">
          <span>
            <a-tag color="red" v-if="text == '1'">已冻结</a-tag>
            <a-tag color="blue" v-else>未冻结</a-tag>
          </span>
        </span> -->
        <span slot="action" slot-scope="text, record">
          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item
                @click="handleJiesuan(record)"
                :disabled="
                  (record.tk_status != 12 && record.tk_status != 14 && record.tk_status != 3) || record.flstatus != 0
                "
                >结算</a-menu-item
              >
              <a-menu-item @click="handleJiedong(record)" :disabled="record.luckdrawTAG != 1">解冻</a-menu-item>
              <a-menu-item @click="handleJiebang(record)" :disabled="record.user_info ? false : true">解绑</a-menu-item>
              <a-menu-item @click="$refs.replaceUidModal.show(record.sub_id, record.id, sourceby)">换绑</a-menu-item>
              <a-menu-item @click="handleTuikuan(record)" :disabled="record.tk_status == 4 || record.tk_status == 13"
                >退款</a-menu-item
              >
              <!-- <a-menu-item @click="handleAddBlacklist(record)">加入黑名单</a-menu-item> -->
              <a-menu-item @click="handleAddBlacklist(record)" disabled="true">
                <a-tooltip placement="bottomLeft" title="请联系官方客服加入店铺黑名单">加入黑名单</a-tooltip>
              </a-menu-item>
            </a-menu>
            <a>
              更多
              <a-icon type="down" />
            </a>
          </a-dropdown>
        </span>
      </s-table>
    </a-card>
    <!-- 下载订单 -->
    <down-modal ref="downModal"></down-modal>
    <!-- 换绑 -->
    <replace-uid-modal ref="replaceUidModal" @ok="$refs.table.refresh(true)"></replace-uid-modal>
    <!-- 加入黑名单 -->
    <add-blacklist-modal ref="addBlacklistModal" @ok="$refs.table.refresh()"></add-blacklist-modal>
  </page-view>
</template>

<script>
import { STable, ExceptionPage } from '@/components'
import SearchRobot from '@/views/components/SearchRobot'
import ReplaceUidModal from '@/views/order-new/modules/ReplaceUidModal'
import OrderApi from '@/api/order-new'
import { PageView } from '@/layouts'
import { ORDER_SYNC_TB } from '@/store/mutation-types'
import { mapActions, mapGetters } from 'vuex'
import DownModal from './modules/DownModal'
import { DATA_ORDER_STATUS, DATA_ORDER_FANLI_STATUS } from './data'
import { mixinOrder } from '@/utils/mixin'
import DemoVideoAlert from '@/views/components/DemoVideoAlert'
import AddBlacklistModal from './modules/AddBlacklistModal'
import moment from 'moment'
export default {
  name: 'OrderTaobao',
  components: {
    PageView,
    STable,
    SearchRobot,
    DownModal,
    ExceptionPage,
    ReplaceUidModal,
    DemoVideoAlert,
    AddBlacklistModal,
  },
  data() {
    return {
      sourceby: 1, // 来源
      currentRobotId: null,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      changeTime: [], // 日期选择器
      // // 批量操作选中的key
      // selectedRowKeys:[],
      // // 批量操作选中的商品项
      // selectedGoods:[],
      // 表头
      columns: [
        {
          title: '#',
          width: 50,
          scopedSlots: { customRender: 'serial' },
        },
        {
          title: '机器人ID',
          width: 100,
          dataIndex: 'sub_id',
          scopedSlots: { customRender: 'sub_id' },
        },
        {
          title: '订单号',
          width: 180,
          dataIndex: 'trade_parent_id',
          scopedSlots: { customRender: 'order_no' },
        },
        {
          title: '主图',
          dataIndex: 'item_img',
          width: 60,
          scopedSlots: { customRender: 'item_img' },
        },
        // {
        //   title: '商品标题',
        //   width: 200,
        //   dataIndex: 'item_title',
        //   scopedSlots: { customRender: 'order_title' },
        // },
        // {
        //   title: '商品ID',
        //   width: 150,
        //   dataIndex: 'item_id',
        // },
        // {
        //   title: '付款金额',
        //   width: 150,
        //   dataIndex: 'alipay_total_price',
        //   sorter: true,
        //   scopedSlots: { customRender: 'rmb_slot' },
        // },
        {
          title: '商品信息',
          width: 200,
          scopedSlots: { customRender: 'goods_info' },
        },
        {
          title: '返利信息',
          width: 260,
          scopedSlots: { customRender: 'order_fanli_Info_slotd' },
        },
        // {
        //   title: '总佣金',
        //   dataIndex: 'total_commission_fee',
        //   sorter: true,
        //   scopedSlots: { customRender: 'total_reward' },
        // },
        {
          title: '认领用户',
          width: 100,
          dataIndex: 'user_info',
          scopedSlots: { customRender: 'user_info' },
        },
        // {
        //   title: '用户奖励',
        //   width: 150,
        //   dataIndex: 'fl_user',
        //   sorter: true,
        //   scopedSlots: { customRender: 'rmb_slot' },
        // },
        // {
        //   title: '上级奖励',
        //   width: 150,
        //   dataIndex: 'fl_agent',
        //   sorter: true,
        //   scopedSlots: { customRender: 'rmb_slot' },
        // },
        // {
        //   title: '上上级奖励',
        //   width: 150,
        //   dataIndex: 'fl_second',
        //   sorter: true,
        //   scopedSlots: { customRender: 'rmb_slot' },
        // },
        // {
        //   title: '群主奖励',
        //   width: 150,
        //   dataIndex: 'fl_group',
        //   sorter: true,
        //   scopedSlots: { customRender: 'rmb_slot' },
        // },
        {
          title: '订单信息',
          width: 220,
          scopedSlots: { customRender: 'order_info' },
          sorter: true,
        },
        // {
        //   title: '订单状态',
        //   width: 100,
        //   dataIndex: 'tk_status',
        //   scopedSlots: { customRender: 'order_status_slot' },
        // },
        // {
        //   title: '返利状态',
        //   width: 100,
        //   dataIndex: 'flstatus',
        //   scopedSlots: { customRender: 'order_fanli_status_slot' },
        // },
        // {
        //   title: '冻结状态',
        //   width: 100,
        //   dataIndex: 'luckdrawTAG',
        //   scopedSlots: { customRender: 'order_dongjie_status_slot' },
        // },
        // {
        //   title: '结算时间',
        //   width: 180,
        //   dataIndex: 'tk_earning_time',
        //   sorter: true,
        //   scopedSlots: { customRender: 'accountdt' },
        // },
        {
          title: '推广位',
          width: 150,
          scopedSlots: { customRender: 'mmpid' },
        },
        // {
        //   title: '创建时间',
        //   sorter: true,
        //   dataIndex: 'tb_paid_time',
        //   scopedSlots: { customRender: 'createdt' },
        // },
        {
          title: '操作',
          width: '80px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],

      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return OrderApi.getTaobaoOrderList(
          Object.assign(parameter, this.queryParam, {
            sub_id: this.currentRobotId,
          })
        ).then(res => {
          this.selectedRowKeys = []
          return res
        })
      },

      robotName: '', // 机器人名称，SearchRobot子组件传值
      searchDrawerVisible: false, // 是否可见
      dateFormat: ['YYYY-MM-DD','YYYY-MM-DD'], // 查询的时间格式
    }
  },
  mixins: [mixinOrder],
  filters: {
    getOrderStatus(status) {
      const dataObj = DATA_ORDER_STATUS
      if (dataObj[status]) {
        return dataObj[status]['text']
      } else {
        return '未知'
      }
    },
    getOrderFanliStatus(status) {
      const dataObj = DATA_ORDER_FANLI_STATUS
      if (dataObj[status]) {
        return dataObj[status]['text']
      } else {
        return '未知'
      }
    },
  },
  computed: {
    OrderDownloadStatus() {
      const taobaoStatus = this.$store.state.order.taobaoStatus
      return taobaoStatus[this.currentRobotId] ? taobaoStatus[this.currentRobotId] : {}
    },
  },
  created() {},
  methods: {
    ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG', 'demoSetVideo']),
    ...mapGetters(['getRobotOrderDownloadStatusById']),
    // 加入黑名单
    handleAddBlacklist(data) {
      this.$refs.addBlacklistModal.show(this.currentRobotId, data)
    },
    onChangeRobotId(e) {
      // console.log("e数组包含：机器人id，机器人名称", e)
      this.currentRobotId = e[0]
      this.robotName = e[1]
      // console.log("传值=",id, nickname)
      // this.robotName = nickname
      // this.currentRobotId = id
      if (this.$refs.table) {
        this.$refs.table.refresh(true)
      }
    },
    handleDownLoad() {
      // const time = this.$ls.get(ORDER_SYNC_TB)
      // if (!(time && +moment() - time < 60 * 60 * 1000)) {
      this.$refs.downModal.show(this.currentRobotId)
      // } else {
      //   this.$message.error('60分钟内请不要重复操作！')
      // }
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleDelete(id) {
      this.$refs.table.refresh()
    },
    // 结算
    handleJiesuan({ id, sub_id }) {
      const orderid = id + ''
      const robotid = this.currentRobotId
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: sub_id,
        type: 'operationorder',
        data: {
          orderid: orderid,
          type: '1',
          sourceby: this.sourceby,
        },
      }).then(result => {
        this.$message.success('发送指令成功')
      })
    },
    // 解冻
    handleJiedong({ id, sub_id }) {
      const orderid = id + ''
      const robotid = sub_id
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: robotid,
        type: 'operationorder',
        data: {
          orderid: orderid,
          type: '2',
          sourceby: this.sourceby,
        },
      }).then(result => {
        this.$message.success('发送指令成功')
      })
    },
    // 退款
    handleTuikuan({ id, sub_id }) {
      const orderid = id + ''
      const robotid = sub_id
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: robotid,
        type: 'operationorder',
        data: {
          orderid: orderid,
          type: '3',
          sourceby: this.sourceby,
        },
      }).then(result => {
        this.$message.success('发送指令成功')
      })
    },
    // 解绑
    handleJiebang({ id, sub_id }) {
      const orderid = id + ''
      const robotid = sub_id
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: robotid,
        type: 'operationorder',
        data: {
          orderid: orderid,
          type: '5',
          sourceby: this.sourceby,
        },
      }).then(result => {
        this.$message.success('发送指令成功')
      })
    },
    // // 多选
    // onSelectChange(selectedRowKeys,rows){
    //   this.selectedRowKeys = selectedRowKeys;
    //   // console.log(this.selectedRowKeys,rows)
    //   this.selectedGoods = rows.map((item)=>{
    //     return {
    //       id:item.id,
    //       sub_id:item.sub_id
    //     }
    //   })
    //   console.log(this.selectedGoods)
    // },
    // 关闭抽屉
    searchDrawerClose() {
      this.searchDrawerVisible = false
    },
    // 展示抽屉
    searchDrawerShow() {
      this.searchDrawerVisible = true
    },
    // 查询按钮
    searchDrawerBtn() {
      console.log('点击抽屉的查询')
      this.$refs.table.refresh(true)
      this.searchDrawerVisible = false
    },
    // 将日期选择器的时间格式化
    formatTime(){
      // console.log('默认值e==',e);
      console.log('日期选择器的参数是=',this.changeTime[0],this.changeTime[1]);
      // 也可以用 new Date() 格式化这个时间
      let firstTime = this.$moment(this.changeTime[0]).format('YYYY-MM-DD')
      let lastTime = this.$moment(this.changeTime[1]).format('YYYY-MM-DD')
      // console.log('两个日期=',firstTime,lastTime);
      this.queryParam.order_deal_time = firstTime + ',' + lastTime
      // console.log('传递的日期参数=',this.queryParam.order_deal_time);
      console.log('传递的日期参数类型是=', Object.prototype.toString.call(this.queryParam.order_deal_time)); // String
    },
  },
}
</script>
<style lang="less" scoped>
.table-operator {
  display: flex;
  flex-direction: row;
  align-items: center;
}
/deep/ .page-header {
  .extra {
    display: none;
  }
  .headerContent {
    flex: 0 1 100% !important;
  }
}
</style>
